import { Component, OnInit } from '@angular/core';
import { CrosstrendService } from 'src/app/services/crosstrend.service';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';

@Component({
  selector: 'app-h1',
  standalone: true,
  templateUrl: './h1.component.html',
  styleUrls: ['./h1.component.scss'],
  imports: [HighchartsChartModule, MdbFormsModule, MdbSelectModule]
})
export class H1Component implements OnInit {

  mercati: any = []

  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  datiTotali: any = []
  minCTBuy: any = ['Qualsiasi']
  minCTSell: any = ['Qualsiasi']
  minBuy: any = 0
  minSell: any = 0

  constructor(private serv: CrosstrendService) {
    for (let i = 0; i < 200; i = i + 10) {
      this.minCTBuy.push(i)
      this.minCTSell.push(-i)
    }
  }

  ngOnInit(): void {
    this.serv.listaMercati().subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        this.mercati = data.data.filter((el: any) => el.tipo == 'Major' || el.tipo == 'Cross')
      }
    })
  }

  cambiaMercato(event: any) {
    console.log(event)
    this.serv.crossTrendH1(event).subscribe((data: any) => {
      console.log(data)
      if (data.res == 'ok') {
        this.datiTotali = data.data//.filter((el: any) => (el.verso == 'buy' && el.m2<0) || (el.verso == 'sell' && el.m1<0))
        this.aggiornaGrafico(this.datiTotali)
      }
    })
  }

  minCrossTrendBuy(event: any) {
    this.minBuy = event
    if (event == 'Qualsiasi') {
      if (this.minSell == 'Qualsiasi') {
        this.aggiornaGrafico(this.datiTotali)
      } else {
        let d = this.datiTotali.filter((el: any) => el.verso == 'sell' && el.crosstrend <= this.minSell)
        this.aggiornaGrafico(d)
      }
      return
    }
    let d = this.datiTotali.filter((el: any) => el.verso == 'sell' || (el.verso == 'buy' && el.crosstrend >= event))
    if (this.minSell != 'Qualsiasi') {
      d = d.filter((el: any) => el.verso == 'buy' || (el.verso == 'sell' && el.crosstrend <= this.minSell))
    }
    this.aggiornaGrafico(d)
  }

  minCrossTrendSell(event: any) {
    this.minSell = event
    if (event == 'Qualsiasi') {
      if (this.minBuy == 'Qualsiasi') {
        this.aggiornaGrafico(this.datiTotali)
      } else {
        let d = this.datiTotali.filter((el: any) => el.verso == 'sell' || (el.verso == 'buy' && el.crosstrend >= this.minBuy))
        this.aggiornaGrafico(d)
      }
      return
    }
    let d = this.datiTotali.filter((el: any) => el.verso == 'buy' || (el.verso == 'sell' && el.crosstrend <= event))
    if (this.minBuy != 'Qualsiasi') {
      d = d.filter((el: any) => el.verso == 'sell' || (el.verso == 'buy' && el.crosstrend >= this.minBuy))
    }
    this.aggiornaGrafico(d)
  }

  aggiornaGrafico(data: any) {
    let tot = 0
    let dd = data.map((el: any) => {
      tot += el.profit
      return tot
    })
    let prezzi = data.map((el: any) => {return parseFloat(el.close)})
    let ser: Highcharts.SeriesOptionsType[] = [
      { name: 'market', type: 'line', data: dd, turboThreshold: 4000 },
      { name: 'cambio', type: 'line', data: prezzi, turboThreshold: 4000,yAxis: 1 },
    ]
    this.chartOptions = {
      title: {
        text: 'Cross Trend H1'
      },
      series: ser,
      yAxis: [
        { title: { text: 'Profit' } },
        { title: { text: 'Cambio' }, opposite: true },
      ],
    }
  }

}
